import { render, staticRenderFns } from "./PricingCards.vue?vue&type=template&id=3b928382&"
import script from "./PricingCards.vue?vue&type=script&lang=js&"
export * from "./PricingCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports